import React from 'react';
import FilePreview from './FilePreview';

interface FileObject {
  name?: string;
  url: string;
}

interface FileGalleryProps {
  files: string[] | FileObject[] | Record<string, any>[];
  className?: string;
}

const FileGallery: React.FC<FileGalleryProps> = ({ files, className }) => {
  if (!files || files.length === 0) {
    return null;
  }

  // Process files to ensure they are in the right format
  const processedFiles = files.map((file, index) => {
    // Handle string URLs
    if (typeof file === 'string') {
      return { url: file };
    }
    
    // Handle object with url property
    if (typeof file === 'object' && 'url' in file) {
      return { 
        url: file.url,
        name: file.name || undefined 
      };
    }
    
    // Handle other objects by trying to extract url and name
    if (typeof file === 'object') {
      // Find a property that might be a URL
      const urlKey = Object.keys(file).find(key => 
        typeof file[key] === 'string' && 
        (file[key].startsWith('http') || key.toLowerCase().includes('url'))
      );
      
      // Find a property that might be a name
      const nameKey = Object.keys(file).find(key => 
        key.toLowerCase().includes('name') || 
        key.toLowerCase().includes('title')
      );
      
      if (urlKey) {
        return {
          url: file[urlKey],
          name: nameKey ? file[nameKey] : undefined
        };
      }
    }
    
    // Return null for items that couldn't be processed
    return null;
  }).filter(Boolean) as FileObject[];

  if (processedFiles.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-wrap gap-2 ${className || ''}`}>
      {processedFiles.map((file, index) => (
        <FilePreview 
          key={index} 
          url={file.url} 
          name={file.name} 
        />
      ))}
    </div>
  );
};

export default FileGallery; 